import React, { Component } from 'react';
import cs from 'classnames';
import PropTypes from 'prop-types';

import Dropdownitem from './DropdownItem';
import './drop-down.css';

class Dropdown extends Component {
	render() {
		const { 
			title,
			options, 
			isActive, 
			toggleDropdown, 
			toggleItem,
		} = this.props;

		const classes = cs(
			"drop-down",
			{ "drop-down--active" : isActive }
		)

		return (
			<div className={classes}>
				<div className="drop-down__title-wrap" onClick={toggleDropdown}>
					<span className="drop-down__title">{title}</span>
					{ isActive ? 
						<span className="material-icons">keyboard_arrow_up</span> :
						<span className="material-icons">keyboard_arrow_down</span>
					}
				</div>
				<ul className="drop-down__list">
					{
						options.map(option => {
							return (
								<Dropdownitem 
								  key={option.id}
									title={option.title}
									selected={option.selected}
									toggleItem={selected => toggleItem(option.id, selected)} />
							)
						})
					}
				</ul>
			</div>
		);
	}
}

Dropdown.propTypes = {
	title: PropTypes.string.isRequired,
	options: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.number.isRequired,
			title: PropTypes.string.isRequired,
			selected: PropTypes.bool,
		}).isRequired,
	).isRequired,
	isActive: PropTypes.bool.isRequired,
	toggleDropdown: PropTypes.func.isRequired,
	toggleItem: PropTypes.func.isRequired,
}

export default Dropdown;


// WEBPACK FOOTER //
// ./src/components/common/files/filters/Dropdown/index.js